import { render } from "./SubscriptionTariffDetail.vue?vue&type=template&id=2f45bfaa"
import script from "./SubscriptionTariffDetail.vue?vue&type=script&lang=js"
export * from "./SubscriptionTariffDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__